import { io } from 'socket.io-client';

class SocketioService {
  socket;
  constructor() {}

  setupSocketConnection() {
    // this.socket = io("https://test.domain:3001/");
    //this.socket = io("https://supportteam.webmoney.com/");
    this.socket = io(process.env.VUE_APP_SOCKET_URL, {transports: ['websocket', 'polling']})
    this.socket.on('connect', () => {
      console.log('Socket connected:', this.socket.id);
    });
    
    this.socket.on('disconnect', () => {
      console.log('Socket disconnected');
      alert("Socket disconnected, please refresh the page");
    });

    this.socket.on('connect_error', (err) => {
      console.error('Socket connection error:', err);
      alert("Socket connection error, please refresh the page");
    });
  }

}

export default new SocketioService();
